import { useLocation } from 'react-router-dom';

export default function useSignAction() {
  const actionMatch = window.location.href.match(/[?&]action=([^&#]+)/);
  const action = actionMatch ? actionMatch[1] : null;
  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);
  // const action = searchParams.get('action');
  const isCompleted = action === 'signing_completed' || action === 'signing_completed_all';
  const status = isCompleted ? 'completed' : null; // 서버에 보낼 상태

  return {
    isCompleted,
    status,
  };
}
